import { GameVars } from "./GameVars";
import { AudioManager } from "./scenes/AudioManager";

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor(config: Phaser.Types.Core.GameConfig) {
        
        super(config);
      
        Game.currentInstance = this;
    }

    public onBlur(): void {

        if (GameVars.addType === 0) {
            AudioManager.forceMute();
        }
        super.onBlur();
    }

    public onFocus(): void {
        if (GameVars.addType === 0) {
            AudioManager.forceUnmute();
        }
        super.onFocus();
    }
}
